import { render, staticRenderFns } from "./nameLinkTemplate.vue?vue&type=template&id=3b5990e3&"
import script from "./nameLinkTemplate.vue?vue&type=script&lang=js&"
export * from "./nameLinkTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports